import { BlogActions, BlogActionTypes } from '../actions/blog.actions';
import { BlogListingModel } from '../models/blog-listing.model';
import { BlogCategory, BlogTag } from '../models/blog-post.model';

export interface State {
  blog_listing_list: Array<BlogListingModel>;
  selected_listing: BlogListingModel;
  blog_categories: Array<BlogCategory>;
  blog_tags: Array<BlogTag>;
  is_blog_info_valid: boolean;
  is_blog_listing_valid: boolean;
  is_loading: boolean;
  error: any;
  is_create_success: boolean;
  is_update_success: boolean;
}

export const initialState: State = {
  blog_listing_list: [],
  selected_listing: null,
  blog_categories: [],
  blog_tags: [],
  is_blog_info_valid: false,
  is_blog_listing_valid: false,
  is_loading: false,
  error: null,
  is_create_success: null,
  is_update_success: null,
};

export function reducer(state = initialState, action: BlogActions): State {
  switch (action.type) {
    case BlogActionTypes.LoadBlogs:
      return { ...state, is_loading: false };

    case BlogActionTypes.LoadBlogsSuccessful:
      return {
        ...state,
        blog_listing_list: action.payload.blog_listings,
        is_loading: false,
      };

    case BlogActionTypes.LoadBlogsFailed:
      return { ...state, is_loading: false };

    case BlogActionTypes.RemoveBlogListingItem:
      return {
        ...state,
        selected_listing: action.payload.new_listing,
        is_blog_listing_valid: action.payload.is_blog_listing_valid,
      };

    case BlogActionTypes.AddBlogListingItem:
      return {
        ...state,
        selected_listing: action.payload.new_listing,
        is_blog_listing_valid: action.payload.is_blog_listing_valid,
      };

    case BlogActionTypes.DidUpdateBlogPost:
      return {
        ...state,
        selected_listing: action.payload.new_listing,
        is_blog_info_valid: action.payload.is_valid_blog_info,
      };

    case BlogActionTypes.LoadBlogCategoriesSuccessful:
      return { ...state, blog_categories: action.payload.categories };

    case BlogActionTypes.LoadBlogCategories:
      return { ...state, is_loading: true };

    case BlogActionTypes.LoadBlogCategoriesFailed:
      return { ...state, is_loading: false };

    case BlogActionTypes.LoadBlogTags:
      return { ...state, is_loading: true };

    case BlogActionTypes.LoadBlogTagsSuccessful:
      return {
        ...state,
        blog_tags: action.payload.tags,
        is_loading: false,
      };

    case BlogActionTypes.LoadBlogTagsFailed:
      return { ...state, is_loading: false };

    case BlogActionTypes.CreateBlogTag:
      return { ...state, is_loading: true, error: null };

    case BlogActionTypes.CreateBlogTagFailed:
      return { ...state, is_loading: false };

    case BlogActionTypes.CreateBlogTagSuccessful:
      return {
        ...state,
        blog_tags: action.payload.blog_tags,
        selected_listing: action.payload.selected_listing,
        is_blog_info_valid: action.payload.is_blog_info_valid,
        is_loading: false,
      };

    case BlogActionTypes.ResetBlogState:
      return {
        blog_listing_list: [],
        selected_listing: action.payload.new_listing,
        blog_categories: [],
        blog_tags: [],
        is_blog_info_valid: false,
        is_blog_listing_valid: false,
        is_loading: false,
        error: null,
        is_create_success: null,
        is_update_success: null,
      };

    case BlogActionTypes.CreateListing:
      return { ...state, is_loading: true, error: null };

    case BlogActionTypes.CreateListingFailed:
      return { ...state, error: action.payload.error, is_loading: false };

    case BlogActionTypes.CreateListingSuccessful:
      return {
        blog_listing_list: action.payload.listings,
        selected_listing: action.payload.new_listing,
        blog_categories: state.blog_categories,
        blog_tags: state.blog_tags,
        is_blog_info_valid: false,
        is_blog_listing_valid: false,
        is_loading: false,
        error: null,
        is_create_success: true,
        is_update_success: null,
      };

    case BlogActionTypes.UpdateListing:
      return { ...state, is_loading: true, error: null };

    case BlogActionTypes.UpdateListingFailed:
      return { ...state, error: action.payload.error, is_loading: false };

    case BlogActionTypes.UpdateListingSuccessful:
      return {
        blog_listing_list: action.payload.listings,
        selected_listing: action.payload.new_listing,
        blog_categories: state.blog_categories,
        blog_tags: state.blog_tags,
        is_blog_info_valid: false,
        is_blog_listing_valid: false,
        is_loading: false,
        error: null,
        is_create_success: null,
        is_update_success: true,
      };

    case BlogActionTypes.LoadBlogListing:
      return { ...state, is_loading: true };

    case BlogActionTypes.LoadBlogListingSuccessful:
      return {
        ...state,
        selected_listing: action.payload.new_listing,
        is_loading: false,
        is_blog_info_valid: action.payload.is_blog_info_valid,
        is_blog_listing_valid: action.payload.is_valid_blog_listing,
      };

    case BlogActionTypes.LoadBlogListingFailed:
      return { ...state, is_loading: false, error: action.payload.error };

    default:
      return state;
  }
}

export const getAllBlogListingsEntities = (state: State) =>
  state.blog_listing_list;
export const getIsBlogListingValidEntities = (state: State) =>
  state.is_blog_listing_valid;
export const getIsBlogInfoValidEntities = (state: State) =>
  state.is_blog_info_valid;
export const getBlogCategoryEntities = (state: State) => state.blog_categories;
export const getBlogListingEntities = (state: State) => state.selected_listing;
export const getBlogTagsEntities = (state: State) => state.blog_tags;
export const getBlogIsLoadingEntities = (state: State) => state.is_loading;
export const getIsCreateSuccess = (state: State) => state.is_create_success;
export const getIsUpdateSuccess = (state: State) => state.is_update_success;
export const getError = (state: State) => state.error;
